module.exports = __webpack_public_path__ + "static/media/chat.f065f0bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/chat.svg
// module id = 792
// module chunks = 0